import { lazy } from "react";

/**
 * @description Lazily load the `SiteAdminPage` component
 *
 * {@link https://react.dev/reference/react/lazy#suspense-for-code-splitting 🔗 Lazy Loading components with Suspense}
 */
export const SiteAdminPageAsync = lazy(async function () {
  return import("./SiteAdminPage").then((module) => ({ default: module.SiteAdminPage }));
});
